import { apiFunction } from "../../apiCall/function"

// The token is sent when the candidate is signed in, so the attempt is linked
// to them; the backend accepts the request without one.
export const getPaper = async () => {
  return await apiFunction("practice/questions", "get", {}, true, false)
}

export const submitPaper = async (attemptId, answers) => {
  return await apiFunction("practice/submit", "post", { attemptId, answers }, true, false)
}
